import React, { Component } from "react";
import CacheBuster from "react-cache-buster";
import { IntlProvider } from "react-intl";
import App from "./App";
import Store from "./components/Store/Store";
import { AudioProvider } from "./components/Audio/AudioProvider";
import MqttProvider from "./components/Mqtt/MqttProvider";
import VarsProvider from "./components/VarsProvider/VarsProvider";
import ErrorBoundary from "./util/ErrorBoundary";
import translations from "./i18n/locales";
import packageInfo from "../package.json";

class ProviderApp extends Component {
  render() {
    let locale = navigator.language || "en-US";
    locale = window.location.search.replace("?locale=", "") || locale;
    const messages = translations(locale);
    return (
      <CacheBuster
        currentVersion={packageInfo.version}
        isEnabled={true}
        isVerboseMode={false}
        loadingComponent={null}
        metaFileDirectory={"."}
      >
        <ErrorBoundary>
          <Store>
            <IntlProvider locale={locale} key={locale} messages={messages}>
              <VarsProvider>
                <AudioProvider>
                  <MqttProvider>
                    <App />
                  </MqttProvider>
                </AudioProvider>
              </VarsProvider>
            </IntlProvider>
          </Store>
        </ErrorBoundary>
      </CacheBuster>
    );
  }
}

export default ProviderApp;
